<template>
    <div class="text_11">
        <nuxt-link to="/lk" @click.native="$emit('close')">{{ $t("lk_main") }}</nuxt-link>
        <nuxt-link to="/lk/info" @click.native="$emit('close')">{{ $t("lk_info") }}</nuxt-link>
        <nuxt-link to="/lk/orders" @click.native="$emit('close')">{{ $t("lk_orders") }}</nuxt-link>
        <nuxt-link to="/lk/favorites" @click.native="$emit('close')">{{ $t("favorites") }}</nuxt-link>
        <nuxt-link to="/lk/addresses" @click.native="$emit('close')">{{ $t("lk_addressess") }}</nuxt-link>
        <nuxt-link to="/lk/subscribes" @click.native="$emit('close')">{{ $t("lk_subscriptions") }}</nuxt-link>
        <nuxt-link to="/lk/return" @click.native="$emit('close')">{{ $t("return") }}</nuxt-link>
        <nuxt-link to="/lk/pps-club" @click.native="$emit('close')">{{ $t("pps_club") }}</nuxt-link>
    </div>
</template>
<script>
export default {
    name: "LkLinks",
};
</script>
<style lang="less" scoped>
a {
    display: block;
    &.nuxt-link-exact-active {
        text-decoration: underline;
        text-underline-offset: 5px;
    }
}
</style>
